var app = angular.module('leonardo');

var TypeTaskFilter = function (TaskService) {
  return function (option) {
    if (!isNull(option)) {
      switch (option.toString()) {
        case TaskService.TYPE_TASK_DOCUMENT:
          return 'Document';
        case TaskService.TYPE_TASK_WORKFLOW:
          return 'Workflow';
        case TaskService.TYPE_TASK_WORK_ORDER:
          return 'Work Order';
        default:
          return 'Template';
      }
    }
    return 'Invalid type';
  };
};

app.filter('typeTask', ['TaskService', TypeTaskFilter]);
